import {
  afterRenderEffect,
  AfterViewInit,
  Component, computed,
  CUSTOM_ELEMENTS_SCHEMA,
  effect, HostListener,
  Inject,
  inject,
  OnInit,
  PLATFORM_ID, ViewChild
} from '@angular/core';
import {HeaderComponent} from "../../common/header/header.component";
import {IonCard, IonCol, IonContent, IonIcon, IonImg, IonLabel, IonRow} from "@ionic/angular/standalone";
import {FooterComponent} from "../../common/footer/footer.component";
import {addIcons} from "ionicons";
import {ribbonOutline, extensionPuzzleOutline, serverOutline, peopleOutline} from "ionicons/icons";
import {LanguageService} from "../../core/language.service";
import {pages} from "../../configs/config";
import {ColumnContentComponent} from '../components/column-content/column-content.component';
import {B2bSectionComponent} from '../components/b2b-section/b2b-section.component';
import {DatePipe, NgClass} from '@angular/common';
import {ContentSwiperSliderComponent} from '../our-services/content-swiper-slider/content-swiper-slider.component';
import { isPlatformBrowser } from '@angular/common';
import {Meta, Title} from '@angular/platform-browser';
import {AboutService} from './about.service';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-about-satel',
    templateUrl: './about-satel.component.html',
    styleUrls: ['./about-satel.component.scss'],
  imports: [
    HeaderComponent,
    IonContent,
    FooterComponent,
    IonIcon,
    ColumnContentComponent,
    IonImg,
    B2bSectionComponent,
    NgClass,
    ContentSwiperSliderComponent,
    DatePipe,
    TranslateModule
  ]
})
export class AboutSatelComponent  implements OnInit, AfterViewInit {
  languageService: LanguageService = inject(LanguageService);
  aboutUsPage: any;
  leasingPage: any;
  satelInNumbers: any = [
    { icon: 'assets/satel_in_numbers/img_1.png', value: '+3000', text: 'Properties Rented'},
    { icon: 'assets/satel_in_numbers/img_2.png', value: '+5000', text: 'Properties Managed'},
    { icon: 'assets/satel_in_numbers/img_3.png', value: '+3650', text: 'Tenants'},
    { icon: 'assets/satel_in_numbers/img_4.png', value: '+24', text: 'Months in Operation'},
    { icon: 'assets/satel_in_numbers/img_5.png', value: '6M', text: 'Properties Rented'},
    { icon: 'assets/satel_in_numbers/img_6.png', value: '100K', text: 'Properties Managed'},
    { icon: 'assets/satel_in_numbers/img_7.png', value: '+220', text: 'Tenant'},
    { icon: 'assets/satel_in_numbers/img_8.png', value: '+30K', text: 'Month in Operation'},
  ];

  config: any;
  @ViewChild(IonContent) content!: IonContent;
  isScrolled: boolean = false;
  scrollPageDown() {
    const nextSection = document.getElementById('section3');
    if (nextSection) {
      this.content.scrollToPoint(0, nextSection.offsetTop, 500); // Smooth scroll to next section
    }
  }
  aboutService: AboutService = inject(AboutService);
  constructor() {
    addIcons( { ribbonOutline, extensionPuzzleOutline, serverOutline, peopleOutline });
    effect(async () => {
      console.log(this.pageContent())
      if (this.languageService.lang()) {
      }
    });
    afterRenderEffect(()=> {

        // @ts-ignore
    //   import('fullpage.js').then((fullpage) => {
    //       // @ts-ignore
    //     import('fullpage.js/dist/fullpage.extensions.min.js').then((extensions) => {
    //         new fullpage.default('#fullpage', {
    //           autoScrolling: true,
    //           navigation: true,
    //           fitToSection: true,
    //           // parallax: true,
    //           anchors: ['firstPage', 'secondPage', 'thirdPage'],
    //           parallaxOptions: {
    //             type: 'reveal',
    //             percentage: 62,
    //             property: 'translate'
    //           },
    //           licenseKey: '3M7S7-5TCTI-WK6T7-KHFE7-LMIPL',
    //         });
    //       });
    //     });
    })
  }

  pageContent = computed(() => this.aboutService.pageContentResource.value()?.content);
  updateDate = computed(() => this.aboutService.pageContentResource.value()?.updatedOn);
  pageImages = computed(() => this.aboutService.pageContentResource.value()?.images);
  isContentLoading = this.aboutService.pageContentResource.isLoading;
  isActive: number = 1;

  getRef(fullPageRef: any) {
  }
  async onScroll($event: any) {
    this.isScrolled = $event.detail.scrollTop > 50;
  }
  setActive(section: number) {
    this.isActive = section;
  }
  // onScroll(event: any) {
  //   const sectionX = document.getElementById('sectionX');
  //   if (sectionX) {
  //     console.log(sectionX);
  //     const rect = sectionX.getBoundingClientRect();
  //     if (rect.bottom <= 0) {
  //       if (!this.isSectionXScrolled) {
  //         this.isSectionXScrolled = true;
  //         this.scrollPageDown();
  //       }
  //     } else {
  //       this.isSectionXScrolled = false;
  //     }
  //   }
  // }

  resetActive() {
    this.isActive = 0;
  }
  ngAfterViewInit() {

    // if (isPlatformBrowser(this.platformId)) {
    // }
  }

  title: Title = inject(Title);
  meta: Meta = inject(Meta);
  async ngOnInit() {

    this.title.setTitle('');

    this.meta.addTags([
      {property: 'og:title', content: 'Our Story | Expert Rentals & Property Management in Riyadh'},
      {name: 'description', content: 'Discover Satel, a trusted name in Riyadh real estate. We offer a wide range of services, including property rentals, tenant placement, and comprehensive property management solutions. Experience the difference with our expertise and personalized service.'},
      {property: 'og:description', content: 'Discover Satel, a trusted name in Riyadh real estate. We offer a wide range of services, including property rentals, tenant placement, and comprehensive property management solutions. Experience the difference with our expertise and personalized service.'},
      {property: 'og:image', content: 'https://satel.sa/assets/satel-og-image.jpg'},
      {property: 'og:site_name', content: 'satel.sa'},
      {property: 'og:url', content: `https://satel.sa/about-satel`},
      {property: 'og:type', content: 'article'},
      {name: 'twitter:site', content: 'satel.sa'},
      {name: 'twitter:title', content: 'Our Story | Expert Rentals & Property Management in Riyadh'},
      {name: 'twitter:description', content: 'Discover Satel, a trusted name in Riyadh real estate. We offer a wide range of services, including property rentals, tenant placement, and comprehensive property management solutions. Experience the difference with our expertise and personalized service.'},
      {name: 'twitter:card', content: 'summary'},
      {name: 'twitter:image', content: 'https://satel.sa/assets/satel-og-image.jpg'}
    ]);
    // this.config = {
    //   licenseKey: '3M7S7-5TCTI-WK6T7-KHFE7-LMIPL',
    //   anchors: ['firstPage', 'secondPage', 'thirdPage', 'fourthPage', 'lastPage'],
    //   menu: '#menu',
    //
    //   // fullpage callbacks
    //   afterResize: () => {
    //     console.log("After resize");
    //   },
    //   afterLoad: (origin: { index: any; }, destination: any, direction: any) => {
    //     console.log(origin.index);
    //   }
    // }
    // this.aboutUsPage = await this.languageService.loadContent(pages.aboutUs);
    // this.leasingPage = await this.languageService.loadContent(pages.leasingAndRental);
  }
}
